import React from "react";
import classes from "./CommonCard.module.css";
const CommonCard = ({ children, className }) => {
  return (
    <div className={[classes.mainWrapper, className].join(" ")}>{children}</div>
  );
};

export default CommonCard;
